import React, { Component, Fragment } from 'react'
import cn from 'classnames'
import { Formik, Form } from 'formik'
import StripeCheckout from 'react-stripe-checkout'
import { getUserInfo, giftRental, hasAuth, getBridgeSchoolMovies } from '../services/api'
import { getThumbnail } from '../services/vimeo'
import { getBrioVideoInformation } from '../services/brio'
import Input from '../components/input'
import moment from 'moment'
import NyaIcon from '../../images/NYA_icon_128x128.jpg'
import Login from '../services/login'

class Ellipses extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = { count: 1 }
    this.update = this.update.bind(this)
  }
  componentDidMount() {
    this.interval = setInterval(this.update, 300)
  }
  componentWillUnmount() {
    clearInterval(this.interval)
  }
  update() {
    let count = (this.state.count % 4) + 1
    this.setState({ count })
  }
  render() {
    let ellipses = '', hidden = ''
    for (let i = 0; i < 5; i++) {
      if (i < this.state.count)
        ellipses += '.'
      else
        hidden += '.'
    }
    return (
      <span className="ellipses">{ellipses}<span className="hidden">{hidden}</span></span>
    )
  }
}

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key))
      return false
  }
  return true
}

export default class BridgeSchoolGift extends Component {
  constructor(props, context) {
    super(props, context)
    
    // Parse movie data from URL params
    const params = new URLSearchParams(this.props.location.search)
    const movieData = {
      vimeoId: params.get('vimeoId') || '',
      title: params.get('title') || '',
      price: parseFloat(params.get('price')) || 0,
      rentalAvailability: parseInt(params.get('rentalAvailability')) || 1
    }

    this.state = {
      state: movieData.vimeoId ? 'initial' : 'selectMovie',
      confirm: false,
      userInfo: getUserInfo(),
      token: null,
      movieData,
      bridgeSchoolMovies: [],
      selectedMovie: null,
      isLoadingMovies: true,
      thumbnailUrls: {},
      successFormValues: {
        firstname: '',
        email: '',
        date: '',
        note: ''
      }
    }

    this.error = this.error.bind(this)
    this.initial = this.initial.bind(this)
    this.loading = this.loading.bind(this)
    this.success = this.success.bind(this)
    this.selectMovie = this.selectMovie.bind(this)
    this.cancelOnClickHandler = this.cancelOnClickHandler.bind(this)
    this.confirmOnClickHandler = this.confirmOnClickHandler.bind(this)
    this.finishOnClickHandler = this.finishOnClickHandler.bind(this)
    this.onMovieSelect = this.onMovieSelect.bind(this)
    this.onBackToMovieSelect = this.onBackToMovieSelect.bind(this)
  }

  componentDidMount() {
    if (!hasAuth()) {
      Login("/account", "/account?screen=bridge-school-gift")
    }
    
    // If coming from URL params with a specific movie, fetch its thumbnail
    const { movieData } = this.state
    if (movieData.vimeoId && !movieData.image) {
      getThumbnail(movieData.vimeoId).then((thumbnailUrl) => {
        this.setState(prevState => ({
          movieData: {
            ...prevState.movieData,
            image: thumbnailUrl
          },
          thumbnailUrls: {
            ...prevState.thumbnailUrls,
            [movieData.vimeoId]: thumbnailUrl
          }
        }))
      }).catch(err => console.error('Failed to fetch movie thumbnail:', err))
    }
    
    // Fetch Bridge School movies
    getBridgeSchoolMovies().then((category) => {
      console.log('Bridge School category:', category)
      const movies = category?.videos || []
      console.log('Bridge School movies:', movies)
      this.setState({ 
        bridgeSchoolMovies: movies,
        isLoadingMovies: false 
      })
      // Fetch thumbnails for all movies
      this.fetchThumbnails(movies)
    }).catch((err) => {
      console.error('Failed to fetch Bridge School movies:', err)
      this.setState({ 
        bridgeSchoolMovies: [],
        isLoadingMovies: false 
      })
    })
  }
  
  fetchThumbnails(movies) {
    movies.forEach((movie) => {
      const { orastreamVideoId, vimeoId } = movie
      
      if (orastreamVideoId) {
        getBrioVideoInformation(orastreamVideoId).then(result => {
          const { cover } = result
          this.setState(prevState => ({
            thumbnailUrls: {
              ...prevState.thumbnailUrls,
              [orastreamVideoId]: cover
            }
          }))
        }).catch(err => console.error('Failed to fetch Brio thumbnail:', err))
      } else if (vimeoId) {
        getThumbnail(vimeoId).then((thumbnailUrl) => {
          this.setState(prevState => ({
            thumbnailUrls: {
              ...prevState.thumbnailUrls,
              [vimeoId]: thumbnailUrl
            }
          }))
        }).catch(err => console.error('Failed to fetch Vimeo thumbnail:', err))
      }
    })
  }

  getContent() { return this[this.state.state]() }

  cancelOnClickHandler() {
    this.setState(state => {
      return { confirm: false, state: 'initial' }
    })
  }
  
  onMovieSelect(movie) {
    const videoId = movie.orastreamVideoId || movie.vimeoId
    const thumbnailUrl = this.state.thumbnailUrls[videoId]
    const movieData = {
      vimeoId: movie.vimeoId || movie.orastreamVideoId,
      title: movie.title,
      price: movie.price || 0,
      image: thumbnailUrl || '',
      rentalAvailability: movie.rentalAvailability || 1
    }
    this.setState({ 
      movieData, 
      selectedMovie: movie, 
      state: 'initial' 
    })
  }
  
  onBackToMovieSelect() {
    this.setState({ state: 'selectMovie', confirm: false })
  }

  confirmOnClickHandler(errors) {
    if (isEmpty(errors)) {
      this.setState(state => {
        return { confirm: true }
      })
    }
  }

  finishOnClickHandler() {
    this.setState({ state: 'initial', confirm: false })
    this.props.history.push('/')
  }

  success() {
    const { successFormValues: { firstname, email, date, note }, movieData } = this.state
    return (
      <div className="content content--success">
        <div className="info-confirm">
          <div className="message-confirm">
            Your gift has been successfully scheduled and will be delivered on the date below
          </div>
          <div className="field">
            <div className="label">Movie</div>
            <div className="value">{movieData.title}</div>
          </div>
          {firstname && <div className="field">
            <div className="label">Recipient</div>
            <div className="value">{firstname}</div>
          </div>}
          {email && <div className="field">
            <div className="label">Email</div>
            <div className="value">{email}</div>
          </div>}
          {date && <div className="field">
            <div className="label">Delivery Date</div>
            <div className="value">{date}</div>
          </div>}
          {note && <div className="field">
            <div className="label">Message</div>
            <div className="value">{note}</div>
          </div>}
        </div>
        <button className="button button--continue" type="button" onClick={this.finishOnClickHandler}>EXPLORE NYA</button>
      </div>
    )
  }

  moviePreview() {
    const { movieData } = this.state
    let displayPrice = movieData.price
    if (movieData.price % 1 === 0) {
      displayPrice = movieData.price.toFixed(2)
    }
    
    return (
      <div className="movie-preview">
        {movieData.image && (
          <div className="movie-thumbnail">
            <img src={movieData.image} alt={movieData.title} />
          </div>
        )}
        <div className="movie-info">
          <h3>{movieData.title}</h3>
          <p className="movie-price">${displayPrice}</p>
          <p className="movie-rental-period">{movieData.rentalAvailability} day rental</p>
        </div>
      </div>
    )
  }
  
  selectMovie() {
    const { bridgeSchoolMovies, isLoadingMovies, thumbnailUrls } = this.state
    
    if (isLoadingMovies) {
      return (
        <div className="content content--message">
          <div className="message">Loading movies<Ellipses /></div>
        </div>
      )
    }
    
    if (!bridgeSchoolMovies || bridgeSchoolMovies.length === 0) {
      return (
        <div className="content content--message">
          <div className="message">No Bridge School movies available at this time.</div>
        </div>
      )
    }
    
    return (
      <div className="content content--select-movie">
        <div className="top-message">
          <p>Select a Bridge School movie to gift</p>
        </div>
        <div className="movie-list">
          {bridgeSchoolMovies.map((movie, idx) => {
            const displayPrice = movie.price % 1 === 0 ? movie.price.toFixed(2) : movie.price
            const videoId = movie.orastreamVideoId || movie.vimeoId
            const thumbnailUrl = thumbnailUrls[videoId]
            
            return (
              <div 
                key={idx} 
                className="movie-item"
                onClick={() => this.onMovieSelect(movie)}
              >
                <div className="movie-item-thumbnail">
                  {thumbnailUrl && <img src={thumbnailUrl} alt={movie.title} />}
                </div>
                <div className="movie-item-info">
                  <h4>{movie.title}</h4>
                  <p className="movie-item-price">${displayPrice}</p>
                  {movie.runningTime && <p className="movie-item-duration">{movie.runningTime}</p>}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  initial() {
    const userInfo = getUserInfo()
    const { movieData } = this.state
    const email = (userInfo.user_metadata && userInfo.user_metadata.customEmail) || userInfo.email
    
    // Calculate price in cents for Stripe
    const priceInCents = Math.round(movieData.price * 100)

    return (
      <Formik
        initialValues={{
          firstname: "",
          email: "",
          date: moment().format("L"),
          note: "",
        }}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, actions) => {
          giftRental({
            token: this.state.token.id,
            firstname: values.firstname,
            email: values.email,
            date: values.date,
            note: values.note,
            movieData: {
              ...movieData,
              price: priceInCents // Send price in cents to backend
            }
          })
            .then((result) => {
              actions.setSubmitting(false)
              this.setState({
                state: "success",
                successFormValues: {
                  firstname: values.firstname,
                  email: values.email,
                  date: values.date,
                  note: values.note
                },
              })
            })
            .catch((err) => {
              actions.setSubmitting(false)
              this.setState({ state: "error" })
            })
        }}
        validate={(values, props) => {
          let errors = {}

          if (!values.firstname) {
            errors.firstname = "Required"
          } else if (values.firstname.length >= 30) {
            errors.firstname = "You have exceeded max number of characters"
          }

          if (!values.email) {
            errors.email = "Required"
          } else if (values.email.length >= 40) {
            errors.email = "You have exceeded max number of characters"
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
          ) {
            errors.email = "Invalid email address"
          }

          if (!values.date) {
            errors.date = "Required"
          } else if (values.date.length >= 30) {
            errors.date = "You have exceeded max number of characters"
          }

          if (!values.note) {
            errors.note = "Required"
          } else if (values.note.length >= 240) {
            errors.note = "You have exceeded max number of characters"
          }
          return errors
        }}
        render={(props) => (
          <Form className="content content--initial">
            <div className="fields-wrapper">
              <div className="top-message">
                {!this.state.confirm && (
                  <p>
                    Gift a movie rental to someone special
                  </p>
                )}

                {this.state.confirm && (
                  <p>
                    Please double check the recipient's email and your
                    message.
                    <br />
                    This can't be undone or edited later.
                  </p>
                )}
              </div>
              
              {this.moviePreview()}

              {!this.state.confirm ? (
                <Fragment>
                  <Input
                    className="input"
                    label="Recipient First Name"
                    limit={30}
                    isFormikField
                    name="firstname"
                  />
                </Fragment>
              ) : (
                <div className="field">
                  <div className="label">Recipient First Name</div>
                  <div className="value">{props.values.firstname}</div>
                </div>
              )}
              {!this.state.confirm ? (
                <Fragment>
                  <Input
                    className="input"
                    label="Recipient Email"
                    limit={40}
                    isFormikField
                    name="email"
                  />
                </Fragment>
              ) : (
                <div className="field">
                  <div className="label">Recipient Email</div>
                  <div className="value">{props.values.email}</div>
                </div>
              )}
              {!this.state.confirm ? (
                <Fragment>
                  <Input
                    className="input date-label"
                    label="Date for Gift Delivery (if ordered for same day, allow up to 1 hour for delivery)"
                    isFormikField
                    isDatePicker
                    name="date"
                    type="date"
                    disabledDays={{ before: moment().toDate() }}
                  />
                </Fragment>
              ) : (
                <div className="field">
                  <div className="label">Date for Gift Delivery</div>
                  <div className="value">{props.values.date}</div>
                </div>
              )}
              {!this.state.confirm ? (
                <Fragment>
                  <Input
                    className="input"
                    label="Message"
                    limit={240}
                    isFormikField
                    isTextArea
                    name="note"
                  />
                </Fragment>
              ) : (
                <div className="field">
                  <div className="label">Message</div>
                  <div className="value">{props.values.note}</div>
                </div>
              )}
            </div>
            {!this.state.confirm && (
              <div className="buttons-wrapper">
                <button
                  className="button clear button--back"
                  onClick={this.onBackToMovieSelect}
                >
                  CHANGE MOVIE
                </button>
                <button
                  className="button button--continue"
                  type="button"
                  onClick={() =>
                    props
                      .validateForm()
                      .then((errors) => this.confirmOnClickHandler(errors))
                  }
                >
                  SUBMIT
                </button>
              </div>
            )}
            {this.state.confirm && (
              <div className="buttons-wrapper">
                <button
                  className="button clear button--back"
                  onClick={this.cancelOnClickHandler}
                >
                  GO BACK
                </button>
                <StripeCheckout
                  token={(token) =>
                    this.onStripeTokenHandler(token, props.submitForm)
                  }
                  stripeKey={process.env.STRIPE_KEY}
                  email={email}
                  amount={priceInCents}
                  billingAddress={true}
                  image={NyaIcon}
                >
                  <button
                    className={cn("button button--continue", {
                      disabled: props.isSubmitting,
                    })}
                    type="button"
                  >
                    PAY
                  </button>
                </StripeCheckout>
              </div>
            )}
          </Form>
        )}
      />
    )
  }

  onStripeTokenHandler(token, submitForm) {
    this.setState({ state: 'loading', token }, () => {
      submitForm()
    })
  }

  loading() {
    return (
      <div className="content content--message">
        <div className="message">loading<Ellipses /></div>
      </div>
    )
  }

  error() {
    return (
      <div className="content content--message">
        <div className="message">Sorry! We were unable to process your gift.<br />Please try again.</div>
        <div className="buttons">
          <div className="button clear" onClick={this.cancelOnClickHandler}>CANCEL</div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="gift-panel panel bridge-school-gift">
        <div className="title">Gift a Movie</div>
        {this.getContent()}
      </div>
    )
  }
}
